import { SEQUENCE_STEPS as STEPS } from '../utils/constants'

const resetResource = (dispatch: any, types: any) => {
  const RESET = Object.keys(types).find(i => types[i].includes(STEPS[3])) || ''
  dispatch({ type: types[RESET] })
}

export default resetResource
